/** @module csi/widget/SimpleTextWithTitle */
define([
	"dojo/_base/declare",
	"dijit/_WidgetBase",
	"csi/html"
], function(declare,_WidgetBase,html) {

	return declare(_WidgetBase, {
		baseClass: "csi-ellipsis-nowrap",
		/** @property {string} text - the text for the label and title */
		text: "",

		/**
		 * Update the value and title, otherwise, the value will be keeping the initialized value
		 * @param {string} value
		 */
		_setTextAttr: function(value) {
			const {domNode} = this;
			this._set("text", value);
			domNode.setAttribute("title", value);
			html.clear(domNode);
			html.text(domNode, value);
		}
	});
});